import React from "react";
import { TweenMax, TimelineMax, Back, Power1 } from "gsap";
import "./GooLoader.css";

class GooLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.svg = React.createRef();
    this.container = React.createRef();
    this.drop = React.createRef();
    this.drop2 = React.createRef();
    this.tm = new TimelineMax({
      repeat: -1,
      paused: false,
      repeatDelay: 0,
      immediateRender: false,
      reversed: true,
    });
  }

  componentDidMount() {
    TweenMax.set(this.svg.current, {
      position: "absolute",
      top: "50%",
      left: "50%",
      xPercent: -50,
      yPercent: -50,
    });
    TweenMax.set(this.container.current, {
      position: "absolute",
      top: "50%",
      left: "50%",
      xPercent: -50,
      yPercent: -50,
    });
    TweenMax.set(this.drop.current, {
      transformOrigin: "50% 50%",
    });
    this.tm.timeScale(3);
    this.tm
      .to(this.drop.current, {
        duration: 4,
        attr: {
          cx: 250,
          rx: "+=10",
          ry: "+=10",
        },
        ease: Back.easeInOut.config(3),
      })
      .to(
        this.drop2.current,
        {
          duration: 4,
          attr: {
            cx: 250,
          },
          ease: Power1.easeInOut,
        },
        "-=4"
      )
      .to(this.drop.current, {
        duration: 4,
        attr: {
          cx: 125,
          rx: "-=10",
          ry: "-=10",
        },
        ease: Back.easeInOut.config(3),
      })
      .to(
        this.drop2.current,
        {
          duration: 4,
          attr: {
            cx: 125,
            rx: "-=10",
            ry: "-=10",
          },
          ease: Power1.easeInOut,
        },
        "-=4"
      );
  }

  render() {
    return (
      <div className="page-loader-container">
        <div className="page-loader-body" ref={this.container}>
          <svg width="400" height="200" viewBox="0 0 400 200">
            <defs>
              <filter id="goo">
                <feGaussianBlur
                  in="SourceGraphic"
                  stdDeviation="7"
                  result="blur"
                />
                <feColorMatrix
                  in="blur"
                  mode="matrix"
                  values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 17 -7"
                  result="cm"
                />
                <feComposite in="SourceGraphic" in2="cm" />
              </filter>
              <filter id="f2" x="-200%" y="-40%" width="400%" height="200%">
                <feOffset in="SourceAlpha" dx="9" dy="3" />
                <feGaussianBlur
                  result="blurOut"
                  in="offOut"
                  stdDeviation="0.51"
                />
                <feComponentTransfer>
                  <feFuncA type="linear" slope="0.05" />
                </feComponentTransfer>
                <feMerge>
                  <feMergeNode />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <g filter="url(#goo)" style={{ fill: "#FFFFFF" }}>
              <ellipse
                ref={this.drop}
                id="drop"
                cx="125"
                cy="90"
                rx="20"
                ry="20"
                fillOpacity="1"
                fill="#ea6b3d"
              />
              <ellipse
                ref={this.drop2}
                id="drop2"
                cx="125"
                cy="90"
                rx="20"
                ry="20"
                fillOpacity="1"
                fill="#ea6b3d"
              />
            </g>
          </svg>
        </div>
      </div>
    );
  }
}

export default GooLoader;

/* 
<script>
	(function() {
		var container = document.getElementById('container');
		var drop = document.getElementById('drop');
		var drop2 = document.getElementById('drop2');
		var outline = document.getElementById('outline');

		TweenMax.set(['svg'], {
			position: 'absolute',
			top: '50%',
			left: '50%',
			xPercent: -50,
			yPercent: -50
		})

		TweenMax.set([container], {
			position: 'absolute',
			top: '50%',
			left: '50%',
			xPercent: -50,
			yPercent: -50
		})

		TweenMax.set(drop, {
			transformOrigin: '50% 50%'
		})

		var tl = new TimelineMax({
			repeat: -1,
			paused: false,
			repeatDelay: 0,
			immediateRender: false
		});

		tl.timeScale(3);
----
		tl.to(drop, 4, {
			attr: {
				cx: 250,
				rx: '+=10',
				ry: '+=10'
			},
			ease: Back.easeInOut.config(3)
		})
        ----
		.to(drop2, 4, {
			attr: {
				cx: 250
			},
			ease: Power1.easeInOut
		}, '-=4')
        ----
		.to(drop, 4, {
			attr: {
				cx: 125,
				rx: '-=10',
				ry: '-=10'
			},
			ease: Back.easeInOut.config(3)
		})
        -----
		.to(drop2, 4, {
			attr: {
				cx: 125,
				rx: '-=10',
				ry: '-=10'
			},
			ease: Power1.easeInOut
		}, '-=4')
	})()
	</script>
*/
